// extracted by mini-css-extract-plugin
export var hideEditor = "_ii-2";
export var infoIcon = "_ii-3";
export var label = "_ii-1";
export var labelContainer = "_ii-0";
export var readonlyText = "_ii-4";